import { ApplicationUser } from '@/types/application-user';
import { isUserOrganisationAdmin } from '../is-user-organisation-admin';
import { isUserPlatformAdmin } from '../is-user-platform-admin';

export const canActiveUserDeleteUser = (
  activeUser: ApplicationUser,
  user: ApplicationUser,
): boolean => {
  // Prevent user from deleting their own account for MVP
  if (activeUser.id === user.id) {
    return false;
  }

  // Platform Admin can delete any account, excluding their own
  if (isUserPlatformAdmin(activeUser)) {
    return true;
  }

  // Org admin cannot delete Platform Admins
  if (isUserOrganisationAdmin(activeUser)) {
    return (
      isUserPlatformAdmin(user) === false
    );
  }

  return false;
};
